import { SensorCoreObject } from './../../../../asp/SensorCoreObject';
import { AppConfig } from './../../../../app.config';
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { VideoPlayerType } from "@core_n/models/camera.model";
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';

@Component({
  selector: 'video-player-selector',
  templateUrl: './video-player-selector.component.html',
  styleUrls: []
})
export class VideoPlayerSelectorComponent {
  @Input() sensor: SensorCoreObject | null = null;
  @Input() public analysedVid: boolean = false;

  constructor(
    protected videomngr: VideoMsgMngrService,
  ) {
  }

  public videoPlayerType: VideoPlayerType = AppConfig.settings.videoAddress.videoPlayerInfo?.type ?? "jwPlayer";
  public signalingUrl = AppConfig.settings.videoAddress.videoPlayerInfo.signalingUrl;
  public videoMuted = AppConfig.settings.videoAddress.videoPlayerInfo.videoMuted;
  public applicationName = AppConfig.settings.videoAddress.videoPlayerInfo.applicationName;
  public tokenObject = null;
  public enableDebugLogging = AppConfig.settings.videoAddress.videoPlayerInfo.enableDebugLogging ?? false;
  public videoPlayerInfo = AppConfig.settings.videoAddress.videoPlayerInfo;

  public isWebRtcResourcesReady = false;

  ngOnChanges(changes: SimpleChanges) {
    if (this.videoPlayerInfo.enableCamSpecificProvider && changes["sensor"]) {
      this.videoPlayerType = this.sensor.providerCameraName ?? this.videoPlayerType;
    }
    if (this.videoPlayerType == "webrtc" || this.videoPlayerType == "flow") {
      this.isWebRtcResourcesReady = false;
      //we're always calling the getCameraWebRtcToken even if the 'webrtcTokenRequired' flag is false
      //since the api also raised the camera's stream the the designated wowza application
      //which we must make sure occre no matter if the wowzaSecureToken is required or not!
      let camName = this.sensor.streamName;
      let streamPrefix = this.videomngr.getStreamPrefixForCameraToken(this.sensor.videoLink, camName);
      this.videomngr.getCameraWebRtcToken(camName, streamPrefix).subscribe(
        (wowzaWebRtcSecureTokenObject) => {
          if (this.videoPlayerInfo.webrtcTokenRequired) {
            this.tokenObject = wowzaWebRtcSecureTokenObject;
          }
          this.isWebRtcResourcesReady = true;
        }
      );
    }
  }
}
